module.exports = __webpack_public_path__ + "media/images/loghi/lba_logo_finals_mob-b0add789347339a5e19204363d753404.png";